var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collective-detail',_vm._b({staticClass:"mt-2",attrs:{"from-welcome":true}},'collective-detail',_vm.currentProperties,false))}
var staticRenderFns = []

export { render, staticRenderFns }